import { SET_EDITCOUPON } from '../actions';

const couponedit = (state = [], action) => {
  switch (action.type) {
	case SET_EDITCOUPON:
      return [...action.value];  
    default: return state;
  }
}

export default couponedit;
